import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function noTradingOnPreMarketCandlesBuilder() {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        System does not currently support trading on pre-market candles.{' '}
      </Body3>
    </td>
  );
}
